var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.338,
    height: 42.338,
    viewBox: "0 0 42.338 42.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4728",
    "data-name": "Trazado 4728",
    d: "M39.681,36.746H8.657A5.663,5.663,0,0,1,3,31.089V22.225a1.225,1.225,0,0,1,2.45,0v8.864A3.21,3.21,0,0,0,8.657,34.3H39.681a3.21,3.21,0,0,0,3.207-3.207V22.225a1.225,1.225,0,0,1,2.45,0v8.864A5.663,5.663,0,0,1,39.681,36.746Z",
    transform: "translate(0 8.592)",
    fill: "#7c9d17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4729",
    "data-name": "Trazado 4729",
    d: "M12.305,13.53a1.225,1.225,0,0,1-.866-.359L.359,2.091A1.225,1.225,0,0,1,2.091.359L12.305,10.572,22.519.359a1.225,1.225,0,1,1,1.733,1.733l-11.08,11.08A1.225,1.225,0,0,1,12.305,13.53Z",
    transform: "translate(36.474 16.53) rotate(180)",
    fill: "#7c9d17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4730",
    "data-name": "Trazado 4730",
    d: "M1.225,29.042A1.225,1.225,0,0,1,0,27.817V1.225a1.225,1.225,0,0,1,2.45,0V27.817A1.225,1.225,0,0,1,1.225,29.042Z",
    transform: "translate(25.393 32.042) rotate(180)",
    fill: "#7c9d17"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.3292dfb776fba6ca36bbd9c0a8db5dec.svg";
export { ForwardRef as ReactComponent };